export const FETCH_MY_BATTERIES_BEGAN = 'myBatteries/FETCH_MY_BATTERIES_BEGAN'
export const FETCH_MY_BATTERIES_SUCCESS = 'myBatteries/FETCH_MY_BATTERIES_SUCCESS'
export const FETCH_MY_BATTERIES_FAILED = 'myBatteries/FETCH_MY_BATTERIES_FAILED'
